/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ThirdPartyConsent = zod.object({
  acceptedAt: zod.iso.datetime({ offset: true }).nullable().describe('ISO 8601 date-time string'),
  termsId: zod.string(),
});

export type ThirdPartyConsent = zod.input<typeof ThirdPartyConsent>;
export type ThirdPartyConsentOutput = zod.output<typeof ThirdPartyConsent>;
